// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1pVdo","links":"Navbar_links__3n5oP","active":"Navbar_active__5o8HY"};